import { Route, Routes } from "react-router-dom";
import NotAllowed from "./components/NotAllowed/NotAllowed";
import Home from "./pages/Home";
import VerifyEmail from "./pages/VerifyEmail";
import AdminEmailVerification from "./pages/AdminEmailVerification";
import { isMobile } from "./Utils";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import ChangeEmailSuccess from "./components/ChangeEmailSuccess/ChangeEmailSuccess";
import ChangePhoneSuccess from "./components/ChangePhoneSuccess/ChangePhoneSuccess";
import LoginRedirect from "./components/LoginRedirect/LoginRedirect";
import MetalDetails from "./pages/MetalDetails";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/app/email/verification-request" element={<AdminEmailVerification />} />
      <Route path="/app/customer/email/verification-request" element={<VerifyEmail />} />
      <Route path="/app/login" element={isMobile() ? <LoginRedirect /> : <NotAllowed />} />
      <Route path="/app/reset-password-request" element={isMobile() ? <ResetPassword /> : <NotAllowed />} />
      <Route path="/app/email/change-request/success" element={isMobile() ? <ChangeEmailSuccess /> : <NotAllowed />} />
      <Route path="/app/number/change-request/success" element={isMobile() ? <ChangePhoneSuccess /> : <NotAllowed />} />
      <Route path="/metal-price-charts" element={<MetalDetails />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default App;
